import { Injectable } from '@angular/core';
import { AppsHttpService } from './apps.http.service';
import { lastValueFrom } from 'rxjs';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import { IAppDetail, IApps, IAppSavePayload, IListQuery, IPageResponse, IPaginatedList } from 'src/app/models';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class AppsService {

  constructor(
    private appsHttpService: AppsHttpService,
    private utilsService: UtilsService,
  ) {}

  async getApps() {
      const source$ = this.appsHttpService.getApps();
      const response = await lastValueFrom(source$);
      return response;
    }

  async getAppsByClient(clientId: number) {
    const source$ = this.appsHttpService.getAppsByClient(clientId);
    const response = await lastValueFrom(source$);
    return response;
  }

  async searchApps(query: IListQuery, active?: boolean): Promise<IPaginatedList<IApps>> {
    const queryParams = this.utilsService.toQueryParams({ ...query, active });
    const response = await lastValueFrom(this.appsHttpService.searchApps(queryParams));
    const apps = objectToCamel(response as object) as { data: IPageResponse<IApps> };
    return this.utilsService.getDataWithPagination(apps.data, query.page);
  }

  async getAppDetail(appId: number): Promise<IAppDetail> {
    const response = await lastValueFrom(this.appsHttpService.getAppDetail(appId));
    return objectToCamel(response as object) as IAppDetail;
  }

  async saveApp(app: IAppSavePayload, appId?: number): Promise<IAppDetail> {
    const body = objectToSnake(app);
    const source$ = appId ? this.appsHttpService.updateApp(appId, body) : this.appsHttpService.createApp(body);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IAppDetail;
  }

  async setAppActive(appId: number, active: boolean) {
    const source$ = active ? this.appsHttpService.reactivateApp(appId) : this.appsHttpService.deactivateApp(appId);
    await lastValueFrom(source$);
  }
}
